/* seen.ts — client-side "has this user seen (finished or closed) this tutorial" flag.

   Deliberately localStorage, not a DB column: whether someone has watched a
   guided setup is cosmetic and device-local is fine. (The real "is the account
   set up" signal lives elsewhere — the ladder rows and the automation regime.) */

const key = (id: string) => `om.tutorial.seen.${id}`;

export function isTutorialSeen(id: string): boolean {
  try {
    return localStorage.getItem(key(id)) === '1';
  } catch {
    return false;
  }
}

export function markTutorialSeen(id: string): void {
  try {
    localStorage.setItem(key(id), '1');
  } catch {
    /* private mode / quota — non-fatal, tutorial just re-offers next visit */
  }
}

export function clearTutorialSeen(id: string): void {
  try {
    localStorage.removeItem(key(id));
  } catch {
    /* ignore */
  }
}
